/**
 * Magic-byte MIME detection — mirror of
 * packages/common/hulahoop_pro_common/mime_detection.py.
 * Keep the signatures and SIGNATURE_PROBE_BYTES in sync with the Python side
 * on the same commit (covered by parity tests on both sides).
 */

export const SIGNATURE_PROBE_BYTES = 16;

type Signature = {
  readonly bytes: Uint8Array;
  readonly mime: string;
};

const SIGNATURES: readonly Signature[] = [
  { bytes: new Uint8Array([0xff, 0xd8, 0xff]), mime: "image/jpeg" },
  {
    bytes: new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]),
    mime: "image/png",
  },
  { bytes: new Uint8Array([0x25, 0x50, 0x44, 0x46]), mime: "application/pdf" }, // %PDF
];

const startsWith = (haystack: Uint8Array, needle: Uint8Array): boolean => {
  if (haystack.length < needle.length) return false;
  for (let i = 0; i < needle.length; i++) {
    if (haystack[i] !== needle[i]) return false;
  }
  return true;
};

/**
 * Detects the canonical MIME type from the leading bytes of a file.
 * Returns `null` when no signature matches — callers decide whether to fall
 * back to the declared (server) content type.
 */
export const detectMimeFromBytes = (content: Uint8Array): string | null => {
  for (const { bytes, mime } of SIGNATURES) {
    if (startsWith(content, bytes)) return mime;
  }
  return null;
};
